export default __webpack_public_path__ + "static/nexxen-543e9e1041aae41157458409cd8d5c47.png";